/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ space: NonNullable<unknown>, project: NonNullable<unknown> }} Uno_Confirm_Link_To_ProjectInputs */



/**
* | output |
* | --- |
* | "Link “{space}” to the project “{project}”" |
*
* @param {Uno_Confirm_Link_To_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_link_to_project = /** @type {((inputs: Uno_Confirm_Link_To_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Link_To_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`„${i?.space}“ mit dem Projekt „${i?.project}“ verknüpfen`)
	return /** @type {LocalizedString} */ (`Link “${i?.space}” to the project “${i?.project}”`)
});